(function() {
  'use strict';

  // Only run on cart page
  if (!window.location.pathname.includes('/cart')) return;

  // Flannel product_id → Hat variant_id
  const PROMO_PRODUCTS = {
    9922597978388: 51197387079956, // Grey → Black hat
    9909408432404: 51197387112724  // Blue → Carmel hat
  };

  let processing = false;

  function showFreeHatMessage(text) {

    if (document.querySelector('.free-hat-banner')) return;

    const banner = document.createElement('div');
    banner.className = 'free-hat-banner';
    banner.innerText = text;

    banner.style.padding = '12px 16px';
    banner.style.background = '#f3f7f3';
    banner.style.border = '1px solid #d9e5d9';
    banner.style.marginBottom = '16px';
    banner.style.fontWeight = '500';
    banner.style.textAlign = 'center';

    const container = document.querySelector('.cart__items');
    if (container) {
      container.prepend(banner);
    }
  }

  async function checkAndSyncHats() {

    if (processing) return;
    processing = true;

    try {

      const response = await fetch('/cart.js');
      const cart = await response.json();

      let flannelCounts = {};
      let hatLineItems = {};

      // Count flannels + track hat line items
      for (const item of cart.items) {

        // Count qualifying flannels
        if (PROMO_PRODUCTS[item.product_id]) {
          const hatVariant = PROMO_PRODUCTS[item.product_id];
          if (!flannelCounts[hatVariant]) flannelCounts[hatVariant] = 0;
          flannelCounts[hatVariant] += item.quantity;
        }

        // Track hats in cart
        if (Object.values(PROMO_PRODUCTS).includes(item.variant_id)) {
          hatLineItems[item.variant_id] = {
            quantity: item.quantity,
            key: item.key
          };
        }
      }

      let reloadNeeded = false;

      // Sync hats for each flannel type
      for (const [hatVariantId, requiredQty] of Object.entries(flannelCounts)) {

        const currentHat = hatLineItems[hatVariantId];
        const currentQty = currentHat ? currentHat.quantity : 0;

        // ADD missing hats
        if (requiredQty > currentQty) {

          const diff = requiredQty - currentQty;

          showFreeHatMessage(
            `🎁 ${diff} free hat${diff > 1 ? 's' : ''} added to your cart`
          );

          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: Number(hatVariantId),
              quantity: diff
            })
          });

          reloadNeeded = true;
        }

        // REMOVE extra hats
        if (currentQty > requiredQty) {

          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: currentHat.key,
              quantity: requiredQty
            })
          });

          reloadNeeded = true;
        }
      }

      // Also remove hats if no qualifying flannels exist at all
      if (Object.keys(flannelCounts).length === 0) {
        for (const hatVariantId in hatLineItems) {

          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: hatLineItems[hatVariantId].key,
              quantity: 0
            })
          });

          reloadNeeded = true;
        }
      }

      if (reloadNeeded) {
        window.location.reload();
      }

    } catch (error) {
      console.error('Free Hat Promo Error:', error);
    }

    processing = false;
  }

  function observeCartChanges() {
    const cartContainer = document.querySelector('.cart__items');
    if (!cartContainer) return;

    const observer = new MutationObserver(() => {
      checkAndSyncHats();
    });

    observer.observe(cartContainer, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    checkAndSyncHats();
    observeCartChanges();
  });

})();